import React, { useState, useContext, useEffect } from "react";
import { Scrollbars } from "react-custom-scrollbars";
import { AppContext } from "./services/context";
import { useLocation, useNavigate } from "react-router-dom";
import { Link, Route, Routes } from "react-router-dom";

import Home from "./pages/Home";
import Header from "./components/header";
import userp from "./assets/imgs/user.png";

import Profile from "./components/profile/Profile";
import Utilisateurs from "./components/utilisateurs";


import Projetadmin from "./components/projets";
import Temoignage from "./components/temoignage";
import CategoriesAdmin from "./components/categories";
import InformationAdmin from "./components/informations";
import Publications from "./components/publications/indexAdmin";
import MemberBureauCRUD from "./components/membreburreau";
import Logo from "./components/logo";

import Question from "./components/forums/indexAdmin";

import Newsletter from "./components/newletters";
import Contacts from "./components/contact";
import Partenaire from "./components/partenaire";
import LienUtileAdmin from "./components/lienutile";
import BesoinAdmin from "./components/besoin";
import CommentaireAdmin from "./components/commentaires";
const admin = () => {
  const authCtx = useContext(AppContext);
  const { user, onUserChange } = authCtx;
  const [org, setOrg] = useState("");
  const [userLocal, setUserLocal] = useState("");
  let navigate = useNavigate();
  const [userImg, setUserImg] = useState(userp);
  // let pathname = props?.location?.pathname;
  const [menu, setMenu] = useState(false);
  const location = useLocation();
  const pathname = location.pathname;

  const { setIsAuth } = useContext(AppContext);
  // const [isSideMenu, setSideMenu] = useState("");
  const [isSideMenuNew, setSideMenuNew] = useState("");
  const [isSideMenuNew2, setSideMenuNew2] = useState("");

  // const { pathname } = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  const [isSideMenu, setIsSideMenu] = useState(localStorage.getItem('isSideMenu') || '');

  const handleMenuClick = (menu) => {
    if (menu !== 'reports') {
      setIsSideMenu('');
      localStorage.removeItem('isSideMenu');
    } else {
      toggleSidebar('reports');
    }
  };
  const toggleSidebar = (menu) => {
    const newMenuState = isSideMenu === menu ? '' : menu;
    setIsSideMenu(newMenuState);
    localStorage.setItem('isSideMenu', newMenuState);
  };

  useEffect(() => {
    const storedMenu = localStorage.getItem('isSideMenu');
    if (storedMenu) {
      setIsSideMenu(storedMenu);
    }
  }, []);

  // const toggleSidebar = (value) => {
  //   setSideMenu(value);
  // };

  const toggleSidebarNew = (value) => {
    setSideMenuNew(value);
  };

  const toggleSidebarNew2 = (value) => {
    setSideMenuNew2(value);
  };

  // eslint-disable-next-line no-unused-vars
  const [isSidebarExpanded, setSidebarExpanded] = useState(false);
  const [isMouseOverSidebar, setMouseOverSidebar] = useState(false);

  useEffect(() => {
    //
  }, [isMouseOverSidebar, user]);



  const deconnect = () => {
    deleteUser();
    onUserChange(initialUser);
  };
  const handleMouseEnter = () => {
    setMouseOverSidebar(true);
  };

  const handleMouseLeave = () => {
    setMouseOverSidebar(false);
  };

  return (
    <>
      {/* <!-- Sidebar --> */}
      <div
        className={`sidebar ${isSidebarExpanded ? "" : "hidden"}`}
        id="sidebar"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        <Scrollbars
          autoHide
          autoHideTimeout={1000}
          autoHideDuration={200}
          autoHeight
          autoHeightMin={0}
          autoHeightMax="95vh"
          thumbMinSize={30}
          universal={false}
          hideTracksWhenNotNeeded={true}
        >
          <div className="sidebar-inner slimscroll">
            <div id="sidebar-menu" className="sidebar-menu">


              <ul>
                <li className="menu-title">
                  <span>Menu</span>
                </li>
                <li className={pathname === "/admin" ? "active" : ""}>
                  <Link to="/admin" onClick={() => handleMenuClick('home')} >
                    <i className="fa fa-home icon-small" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                    <span>Accueil</span>
                  </Link>
                </li>
                <li className={pathname?.includes("projet") ? "active" : ""}>
                  <Link to="/admin/projet" onClick={() => handleMenuClick('projet')}>
                    <i className="fa fa-folder icon-small" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                    <span>Projets</span>
                  </Link>
                </li>


                <li className={pathname?.includes("information") ? "active" : ""}>
                  <Link to="/admin/information" onClick={() => handleMenuClick('information')}>
                    <i className="fa fa-info-circle" style={{ marginRight: '8px', fontSize: '16px' }}></i>{" "}
                    <span>Actualités</span>
                  </Link>
                </li>

                <li className={pathname?.includes("membre") ? "active" : ""}>
                  <Link to="/admin/membre" onClick={() => handleMenuClick('member')}>
                    <i className="fa fa-users icon-small" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                    <span>Utilisateurs</span>
                  </Link>
                </li>


                <li className={pathname?.includes("contacts") ? "active" : ""}>
                  <Link to="/admin/contacts" onClick={() => handleMenuClick('contacts')}>
                    <i className="fa fa-phone icon-small" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                    <span>Contact</span>
                  </Link>
                </li>

                <li className={pathname?.includes("newletters") ? "active" : ""}>
                  <Link to="/admin/newletters" onClick={() => handleMenuClick('newletters')}>
                    <i className="fa fa-envelope icon-small" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                    <span>Newsletters</span>
                  </Link>
                </li>




                <li className={pathname?.includes("publication") ? "active" : ""}>
                  <Link to="/admin/publication" onClick={() => handleMenuClick('publication')}>
                    <i className="fa fa-briefcase" style={{ marginRight: '8px', fontSize: '16px' }}></i> <span>Publication</span>
                  </Link>
                </li>
                <li className={pathname?.includes("forum") ? "active" : ""}>
                  <Link to="/admin/forum">
                    <i className="fa fa-comments" style={{ marginRight: '8px', fontSize: '16px' }}></i> <span>Forums</span>
                  </Link>
                </li>
                <li className={pathname?.includes("lienutile") ? "active" : ""}>
                  <Link to="/admin/lienutile">
                    <i className="fa fa-link" style={{ marginRight: '8px', fontSize: '16px' }}></i> <span>Lien utile</span>
                  </Link>
                </li>
                <li className={pathname?.includes("membreburreau") ? "active" : ""}>
                  <Link to="/admin/membreburreau">
                    <i className="fa fa-user-friends" style={{ marginRight: '8px', fontSize: '16px' }}></i> <span>Membre du burreau</span>
                  </Link>
                </li>
                <li className={pathname?.includes("besoinadmin") ? "active" : ""}>
                  <Link to="/admin/besoinadmin">
                    <i className="fa fa-list-check" style={{ marginRight: '8px', fontSize: '16px' }}></i> <span>Besoins</span>
                  </Link>
                </li>



                <li className="submenu">
                  <Link
                    to="#"
                    className={isSideMenu == "reports" ? "subdrop" : ""}
                    onClick={() =>
                      handleMenuClick('reports')
                    }
                  >
                    <i className="fe fe-document" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                    <span> Paramètres</span> <span className="menu-arrow"></span>
                  </Link>
                  {isSideMenu == "reports" ? (
                    <ul
                      style={{
                        display: isSideMenu == "reports" ? "block" : "none",
                      }}
                    >


                      <li className={pathname?.includes("logo") ? "active" : ""}>
                        <Link to="/admin/logo">
                          <i className="fa fa-image" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                          <span disa>Logo</span>
                        </Link>
                      </li>

                      <li className={pathname?.includes("categories") ? "active" : ""}>
                        <Link to="/admin/categories">
                          <i className="fa fa-cogs" style={{ marginRight: '8px', fontSize: '16px' }}></i>
                          <span>Domaines</span>
                        </Link>
                      </li>

                      <li className={pathname?.includes("partenaire") ? "active" : ""}>
                        <Link to="/admin/partenaire">
                          <i className="fa fa-handshake" style={{ marginRight: '8px', fontSize: '16px' }}></i> <span>Partenaires</span>
                        </Link>
                      </li>
                      {/* <li className={pathname?.includes("membreburreau") ? "active" : ""}>
        <Link to="/admin/membreburreau">
          <i className="fa fa-users" style={{ marginRight: '8px', fontSize: '16px' }}></i> <span>Membre du burreau</span>
        </Link>
      </li> */}
                    </ul>
                  ) : (
                    ""
                  )}
                </li>




              </ul>
            </div>
          </div>
        </Scrollbars>
      </div>
      {/* <!-- /Sidebar --> */}
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />

        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/newletters" element={<Newsletter />} />
          <Route path="/profile" element={<Profile />} />

          <Route path="/Membre" element={<Utilisateurs />} />
          <Route path="/temoignage" element={<Temoignage />} />
          <Route path="/projet" element={<Projetadmin />} />
          <Route path="/categories" element={<CategoriesAdmin />} />
          <Route path="/information" element={<InformationAdmin />} />
          <Route path="/publication" element={<Publications />} />

          <Route path="/forum" element={<Question />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/partenaire" element={<Partenaire />} />
          <Route path="/logo" element={<Logo />} />
          <Route path="/membreburreau" element={<MemberBureauCRUD />} />
          <Route path="/lienutile" element={<LienUtileAdmin />} />
          <Route path="/besoinadmin" element={<BesoinAdmin />} />


        </Routes>
      </div>
    </>
  );
};

export default admin;
